import { ArrowLeftCircleFill, ArrowRightCircleFill } from "react-bootstrap-icons";
import styled, { css } from "styled-components";

export const MonthContainer = styled.div`
    display:flex;
    justify-content:center;
    align-items: stretch;
`;
export const ArrowContainer = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    width: 5%;
   
`;
export const MonthWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items: center;
    flex-grow: 8
`;
const iconStyle = css`
    color:var(--main-teal-color);
    font-size:24px;
    cursor:pointer;
    transition: 0.2s;
    :hover {
        font-size: 45px;
    }
    @media (min-width: 1100px) {
        font-size:32px;
    }
`;
export const ArrowLeft = styled(ArrowLeftCircleFill)`
    ${iconStyle}
`;
export const ArrowRight = styled(ArrowRightCircleFill)`
    ${iconStyle}
`;
export const Month = styled.h3`
     font-family: Lato-Bold;
     color: var(--main-teal-color);
     font-size:2em;
`;